import React from "react";

export default function ValersNestStoryText() {
  return (
    <>
      <p>
        <span>Valer lay awake staring at the ceiling.</span>
      </p>
      <p class="c2">
        <span>
          Tossing and turning with frustration all night, he had hardly slept.
          Delivering the cart of arms and armor to the forward camps had
          accentuated his feelings of uselessness, and a no small amount of
          shame. His friend Clay, a newly minted officer in the Vale Army, had
          been the one to take delivery. It stung that Clay had joined when he
          could not. Especially since both of them knew that Valer was the
          better swordsman,{" "}
        </span>
        <span class="c7">and</span>
        <span class="c1">
          &nbsp;shieldsman. Valer even achieved better scores in Dwarvish than
          Clay. Worse, Clay had been genuinely friendly. Smiling broad and
          telling his men and the other officers how great Valer was growing up.
          They all must think him a coward. Why else would Valer not join the
          Army of the Vale? He was clearly fit and, according to the stories
          Clay was telling, he was more than capable. Yep, clearly a coward. Why
          else would he be getting paid five copper an hour when he could be
          making ten times that as an officer. Valer sighed heavily. The dawn
          light was arriving, may as well get up and get down to the stock
          houses early. Travis had a large shipment of arrows and boots that
          needed to be crated and loaded by the end of the day. Valer was his
          best worker and Travis would need him there to get things moving or
          Travis would be in trouble with the guild. &nbsp;Maybe he could get an
          extra four copper from Travis for being early and drop into the map
          house this evening. Elsk&rsquo;s map was always fun to look at and
          folk said he started work on the Frozenfar last week.
        </span>
      </p>
      <p class="c0">
        <span class="c1"></span>
      </p>
      <p class="c2">
        <span class="c1">
          Fifteen minutes later Valer was crossing the Dwarfbridge on his way to
          the Bell Market storehouses. The morning was dark and chilly, as
          usual, Everlund didn&rsquo;t have magic to keep it warm like
          Silvermoon. Even though it was March, ice was still on the bridge.
          Valer stopped part way along the bridge and sighed. &nbsp;Soaking in
          the calm silence of the vacant early morning. Valer walked to the edge
          of the bridge and watched the cold water flowing past, the morning
          mist rolling along the banks. Valer leaned against the stone work and
          let his shoulders slump. He knew Travis needed his help to set up, but
          Valer couldn&rsquo;t force himself to plod along happily. Staring at
          the River Rauvin flowing along, he couldn&rsquo;t help thinking that
          the waters passing in front of his eyes would soon be in Silverymoon
          in only a few hours, then it would travel all the way around the
          Evermoors. This water could be in Triboar in a few days. Not him
          though. Maybe those ships, and their crates sitting on the dock, but
          not him. He &ldquo;wasn&rsquo;t ready&rdquo; if you asked his Dad -or
          Aster- his melee teacher. Obviously his Mom agreed, but that&rsquo;s
          what mothers do, keep you from scraping your chin.
        </span>
      </p>
      <p class="c0">
        <span class="c1"></span>
      </p>
      <p class="c2">
        <span class="c1">
          &ldquo;Cold morning.&rdquo; &nbsp;The sudden rough voice startled
          Valer. He had been drifting along in his own morose thoughts and
          didn&rsquo;t notice Levant had stepped up next to him.
        </span>
      </p>
      <p class="c0">
        <span class="c1"></span>
      </p>
      <p class="c2">
        <span class="c1">
          &ldquo;Oh, uh, morning sir.&rdquo; Valer mumbled in reply. Not really
          welcoming the intrusion. Levant was friends with Aster and therefore
          likely to side with him about his &ldquo;readiness&rdquo; and Valer
          didn&rsquo;t feel he could take another round of questioning or advice
          giving. So he didn&rsquo;t say anything more.
        </span>
      </p>
      <p class="c0">
        <span class="c1"></span>
      </p>
      <p class="c2">
        <span class="c1">
          Levant didn&rsquo;t offer anything further so they both stood in
          silence for a while just staring at the water as the stars were slowly
          overpowered by the slowly growing morning. Eventually Levant said
          &ldquo;Well, have a good day. It&rsquo;s time I get to bed. I&rsquo;m
          not as young as I was in my adventuring days,&rdquo; and stepped away,
          turning to continue along his way.
        </span>
      </p>
      <p class="c0">
        <span class="c1"></span>
      </p>
      <p class="c2">
        <span class="c1">
          &ldquo;Going to bed? But the day&rsquo;s just starting.&rdquo; Valer
          said to his back with confusion.
        </span>
      </p>
      <p class="c0">
        <span class="c1"></span>
      </p>
      <p class="c2">
        <span class="c1">
          &ldquo;Oh, my day&rsquo;s just ending Valer. I had a lot to do and not
          much time to do it. Besides, I need my skills to be bright and sharp
          tonight.&rdquo;
        </span>
      </p>
      <p class="c0">
        <span class="c1"></span>
      </p>
      <p class="c2">
        <span class="c1">
          Valer&rsquo;s brow lowered in confusion at this statement, his mind
          thoroughly turned around. The only people that spoke about doing work
          at night and sleeping through the day were thieves and bandits, or
          thieves that posed as merchants, but Valer knew Levant was a well
          respected member of Sarthun&rsquo;s Shield and the community. Valer
          even heard his father say the merchants guild was very appreciative of
          Levant&rsquo;s help on several occasions. Valer tried to voice his
          confusion but his words sounded just as confused as he felt.
        </span>
      </p>
      <p class="c0">
        <span class="c1"></span>
      </p>
      <p class="c2">
        <span>
          A slow understanding grin emerged on Levant&rsquo;s face. &ldquo;Why
          don&rsquo;t you come over to the Missing Minotaur this evening? After
          you&rsquo;re done at the store house. It&rsquo;ll be a lot easier to
          show you what we&rsquo;ve been up to, than to explain it.&rdquo;
        </span>
      </p>
      <p class="c0">
        <span class="c1"></span>
      </p>
      <p class="c2">
        <span class="c1">
          &ldquo;Um, okay.&rdquo; Valer replied slowly, his eyes narrowed in
          mild suspicion. His brain worked to try to figure out what he could
          possibly be getting himself into. He trusted Levant fully, and so did
          everyone else he knew. So it must not be too bad. Levant&rsquo;s grin
          grew wider.
        </span>
      </p>
      <p class="c0">
        <span class="c1"></span>
      </p>
      <p class="c2">
        <span class="c1">
          &ldquo;Good! I&rsquo;ll see you then. This is gonna be fun!&rdquo; and
          his grin grew to a wide smile as he turned and strode down the bridge
          away from Valer. Waving over his shoulder as he walked.
        </span>
      </p>
      <p class="c0">
        <span class="c1"></span>
      </p>
      <p class="c2">
        <span class="c1">
          Valer, confused and amused, turned and continued toward the store
          house. His morose thoughts left in the river as he wondered what that
          was all about. At least his evening was going to be entertaining it
          seemed. Valer was still wondering what Levant could be up to when he
          arrived at Travis&rsquo; storehouse. The chill morning seemed a bit
          colder once he reached the door. Travis already had the door open and
          the oil lamps lit. Valer could hear him setting out the boxing tools,
          getting ready for the heavy work the day had in store. Valer sighed
          and shook his head. Travis really needed to pay more attention to the
          numbers. It was going to be a stretch to get this delivery loaded by
          daylight&#39;s end.
        </span>
      </p>
      <p class="c0">
        <span class="c1"></span>
      </p>
      <p class="c2">
        <span class="c1">
          Twelve hours later Valer lifted the last crate of boots up to the
          loaders and stretched his back.It had been a long day. His hands felt
          raw through his gloves, and scrapes on his arms and chest from loading
          crates that stung earlier in the day now felt numb. His shirt had tiny
          specks of blood from the scrapes and it was soaked through with sweat,
          but they had made it. Travis had made good on his deal, and was going
          to turn a very good profit. Valer had helped him with the numbers to
          make today happen. The smile on Travis&rsquo; face was as broad as his
          face as he came over to slap Valer&rsquo;s shoulder in
          congratulations.
        </span>
      </p>
      <p class="c0">
        <span class="c1"></span>
      </p>
      <p class="c2">
        <span class="c1">
          &ldquo;Well boy. We did it. Thanks in no small part to you!&rdquo;
          Travis stated proudly.
        </span>
      </p>
      <p class="c0">
        <span class="c1"></span>
      </p>
      <p class="c2">
        <span class="c1">
          &ldquo;Yeah. I need an Ale. Hey Travis, do you think I could get an
          extra four coppers for turning up early today? Just for an extra ale
          you know.&rdquo; Valer felt uncomfortable asking for the extra money,
          but felt he earned it. Plus he didn&rsquo;t really have the money for
          Ale otherwise.
        </span>
      </p>
      <p class="c0">
        <span class="c1"></span>
      </p>
      <p class="c2">
        <span class="c1">
          Chuckling, Travis smiled broadly and rubbed his chin. &ldquo;Hmm.
          Okay. Let me go see what I can do for you Valer.&rdquo;
        </span>
      </p>
      <p class="c0">
        <span class="c1"></span>
      </p>
      <p class="c2">
        <span class="c1">
          Fifteen minutes later Valer was sitting on a crate outside, his face
          turned towards the sky. Watching the sky turning deeper purple and
          naming to himself stars as they started to wink on.Travis walked back
          across the storehouse floor holding some coins in his hand, and
          stopped next to Valer, looking up at the sky in turn.
        </span>
      </p>
      <p class="c0">
        <span class="c1"></span>
      </p>
      <p class="c2">
        <span class="c1">
          &ldquo;You always have loved the stars,&rdquo; said Travis.
        </span>
      </p>
      <p class="c2">
        <span class="c1">
          &ldquo;Yeah. Just something about them that tugs at me I guess.&rdquo;
          replied Valer.
        </span>
      </p>
      <p class="c2">
        <span class="c1">
          &ldquo;Well, here you are. Have fun at the map house. Don&rsquo;t lose
          it, and don&rsquo;t spend it all!&rdquo; Travis said this last with a
          raised brow and a stern look. &ldquo;You did right by me, and this is
          me saying thank you.&rdquo; Travis held out a small sack of coins to
          Valer.
        </span>
      </p>
      <p class="c0">
        <span class="c1"></span>
      </p>
      <p class="c2">
        <span class="c1">
          &nbsp;Valer&rsquo;s brow lowered and head tilted in confusion, and he
          met Travis&rsquo; eye in question. To which Travis nodded and gestured
          with the small sack for Valer to take it. Which Valer did.
        </span>
      </p>
      <p class="c0">
        <span class="c1"></span>
      </p>
      <p class="c2">
        <span class="c1">
          &ldquo;Good luck Valer.&rdquo; and with that Travis disappeared
          inside. Leaving a confused Valer to glimpse in the purse to find five
          gold coins, and four copper. Valer let out a sound of delighted
          surprise, and a broad smile.
        </span>
      </p>
      <p class="c0">
        <span class="c1"></span>
      </p>
      <p class="c2">
        <span class="c1">
          &ldquo;Thank you!&rdquo; Valer shouted across the empty store room.
          Loud enough that Travis could hear. Then turned and excitedly strode
          away from the store house, towards his mysterious meeting with Levant.
          His steps light, back straight, and thoughts racing through his head
          of what he could do with his new found fortune. It felt like a lot,
          but he had enough experience trading goods to know what he could, and
          could not, do with his money. After some thought walking and thinking,
          he decided he would save three gold, spend one on some good working
          gear, and the last on fun. On a whim, Valer decided to take the scenic
          route and turned down the street that would lead him past the
          Harper&rsquo;s Tower. It was a beautiful tower and the grounds around
          it were always inspiring. There was some magic imbued in some of the
          sculptures that made the glow softly, and magical fairy lights that
          was always something to see.
        </span>
      </p>
      <p class="c0">
        <span class="c1"></span>
      </p>
      <p class="c2">
        <span class="c1">
          However as Valer approached the grounds his attention was diverted
          away from the art, instead to the group of eight at the entrance
          gates. Several of them were wearing armor and all seemed armed. One
          was wearing a very nice breastplate, and Valer had never seen a bow
          that nice. Four of them were standing in a tight circle having an
          intense discussion. While the other four were vigilant. Eyeing passers
          by, seeming to size each one up as they passed the group by. Valer
          noticed a dwarf was staring right at him. The dwarf seemed to mutter
          something to himself then, as if in reaction to the dwarf&rsquo;s
          mutters, the entire group looked right at Valer. Watching him
          expectantly.
        </span>
      </p>
      <p class="c0">
        <span class="c1"></span>
      </p>
      <p class="c2">
        <span>
          Quickly Valer veered away from the group, giving them a wide berth,
          and look, to say &ldquo;what&rsquo;s wrong with you lot?&rdquo; and
          widened his stride toward the tavern. They were probably Harpers, or
          adventurers hired by the Harpers, he thought. Those folks were always
          a bit strange, but, at least they weren&rsquo;t cowards. At least{" "}
        </span>
        <span class="c7">they</span>
        <span class="c1">
          &nbsp;were doing something interesting. Maybe even helping to keep the
          Vale safe. Who knew with adventurers though. They were a hit and miss
          lot.
        </span>
      </p>
      <p class="c0">
        <span class="c1"></span>
      </p>
      <p class="c2">
        <span class="c1">
          Valer stepped into the tavern. Valer really did love this place. The
          warm air and warm glow from the lanterns and large stone hearth made
          it feel safe. The second story balcony overlooking the common area
          with carved stone lamps made it beautiful. But for Valer, the large
          map in the main room was what made this tavern the best tavern. The
          stories that Aster and the other members of Sarthun&rsquo;s Shield
          told around that map filled Valer&rsquo;s dreams. Staring at that map
          his dreams bubbled. One day he would visit Silverymoon, maybe even
          fight orcs along the road to Sarthun.
        </span>
      </p>
      <p class="c0">
        <span class="c1"></span>
      </p>
      <p class="c2">
        <span class="c1">
          &rdquo;Valer! Glad you came. We saved you a seat. Come on.&rdquo;
          Levant slid out of the crowd clapping Valer on the shoulder and began
          leading him to a spot across from the map table.
        </span>
      </p>
      <p class="c0">
        <span class="c1"></span>
      </p>
      <p class="c2">
        <span class="c1">
          &rdquo;One second, I want to grab an ale. Travis gave some extra
          coppers for one.&rdquo;
        </span>
      </p>
      <p class="c0">
        <span class="c1"></span>
      </p>
      <p class="c2">
        <span class="c1">
          &ldquo;Keep your copper for another night Valer, we have several
          pitchers. Come on. Oh and just follow our lead, okay? Great.&rdquo;
        </span>
      </p>
      <p class="c0">
        <span class="c1"></span>
      </p>
      <p class="c2">
        <span class="c1">
          Levant guided him to a table where a couple members of Sarthun&rsquo;s
          Shield sat. &nbsp;Aster (Valer&rsquo;s melee teacher), and Botan
          (Valer didn&rsquo;t really know much about him). Along with three men
          Valer didn&rsquo;t recognize, and who clearly weren&#39;t members of
          Sarthun&rsquo;s Shield. They were dressed in very nice clothes and
          seemed to have an eir about them. It felt like they thought they knew
          something you didn&rsquo;t, and found your ignorance funny. Valer
          instantly felt a dislike for all three of them. Levant gestured to a
          chair for Valer to sit and poured him a large Ale, then filled
          everyone&rsquo;s mugs and gestured for another.
        </span>
      </p>
      <p class="c0">
        <span class="c1"></span>
      </p>
      <p class="c2">
        <span class="c1">
          &rdquo;I&rsquo;d prefer a good wine, actually. Actually, I think we
          all would, wouldn&rsquo;t we?&rdquo; This from the center well dressed
          man.
        </span>
      </p>
      <p class="c2">
        <span>&rdquo;Oh yes, I certainly prefer </span>
        <span class="c7">good</span>
        <span class="c1"> &nbsp;wine. Andrew, wouldn&rsquo;t you?&rdquo; </span>
      </p>
      <p class="c2">
        <span class="c1">&rdquo;Yes good idea Sam.&rdquo;</span>
      </p>
      <p class="c2">
        <span class="c1">&ldquo;Red. If you please.&rdquo;</span>
      </p>
      <p class="c0">
        <span class="c1"></span>
      </p>
      <p class="c2">
        <span>
          Without hesitation Levant deftly ordered wine from the barmaid
          Jessica. Who had wine at the table before Levant finished taking his
          seat. Along with some of the best bread and roast duck to be found in
          Everlund. All with some of the most beautiful plates and cups that
          Valer had ever seen, and had never seen at this tavern. What was going
          on? The Missing Minotaur didn&rsquo;t serve this food, and certainly
          not on{" "}
        </span>
        <span class="c7">this</span>
        <span>&nbsp;tableware. Come to think of it Jessica had </span>
        <span class="c7">never</span>
        <span class="c1">
          &nbsp;served anything that quickly to anyone, but the three men across
          the table were smiling greedily. Their eyes drinking in everything on
          the table.
        </span>
      </p>
      <p class="c0">
        <span class="c1"></span>
      </p>
      <p class="c2">
        <span>
          Valer looked to Aster, who just winked subtly and nodded at Valer to
          drink his ale. Valer looked at Botan who smiled and took a swig from
          his ale, and helped himself to some duck. Even more confused, Valer
          looked finally to Levant who simply suggested Valer have some duck,
          and that it really was very good. So Valer had some of the duck,
          bread, cheese and ale. The duck was glazed and the skin was crispy and
          sweet. While the meat was moist and falling off the bone. It was
          incredible. Such a rich and powerful flavor. The warm fresh bread
          which did well to soak up the juices flowing from the duck. The cheese
          was not too sharp, but plenty of flavor. Perfectly adding to the
          flavors without overpowering them. It was without question one of the
          best meals Valer had ever had. It would&rsquo;ve been the best if he
          knew <i>why </i>
          he was eating a great dinner. How did all this tie into what Levant
          had been doing last night? Well, they were sure to get around to it
          when they were ready.
        </span>
      </p>
      <p class="c0">
        <span class="c1"></span>
      </p>
      <p class="c2">
        <span class="c1">
          After some twenty minutes, Valer tuned back into the table
          conversation. Finishing his second mug of ale as he washed down the
          last of the bread, and took a deep satisfied breath.
        </span>
      </p>
      <p class="c0">
        <span class="c1"></span>
      </p>
      <p class="c2">
        <span class="c1">
          &ldquo;Well I think we can certainly arrange that.&rdquo; chuckled
          Aster in a friendly way. &ldquo;We have the coin, and you have what we
          need to make more!&rdquo; Aster gestured to Levant in a dismissive
          sort of way. &ldquo;Why don&rsquo;t you and I hammer out the last
          small details over some Bramblerose Whiskey by the fire. Levant, Botan
          and your boys can go take care of the carts. It&rsquo;s not safe to
          leave them on the streets, my competition is jealous!&rdquo;
        </span>
      </p>
      <p class="c0">
        <span class="c1"></span>
      </p>
      <p class="c2">
        <span class="c1">
          Valer noticed the middle man looked a little uneasy at Aster&rsquo;s
          suggestion. The other two, Andrew and Sam,? Had gave each other
          definite looks of concern. One giving a very slow and subtle shake of
          his head.
        </span>
      </p>
      <p class="c0">
        <span class="c1"></span>
      </p>
      <p class="c2">
        <span class="c1">
          Valer quickly leaped into the conversation, attempting to reinforce
          Aster&rsquo;s attempt to separate the three. &ldquo;Those overloaded
          wagons in the alley? I saw a couple of guys peeking in one of the
          crates as I came in. If I knew it was yours I would have said
          something.&rdquo;
        </span>
      </p>
      <p class="c0">
        <span class="c1"></span>
      </p>
      <p class="c2">
        <span>
          At this revelation the two men stood quickly and made for the door.
          Levant and Botan following right behind. Aster stopped the middle man
          with a hand. &ldquo;Your men can handle it. I&rsquo;m sure it was
          nothing, and they&rsquo;ll let you know if they need any help. How
          about that Bramblerose Whisky?&rdquo; Aster smiled and gestured to
          some comfortable chairs by the fire. &ldquo;Valer, you know your way
          around the storehouses, and I&rsquo;m sure Levant would be glad for
          your help.&rdquo; Valer stood to go, and Jessica set a very nice
          looking bottle next to Aster.
        </span>
      </p>
      <p class="c0">
        <span class="c1"></span>
      </p>
      <p class="c2">
        <span class="c1">
          Outside Valer found the two men, up on the wagon in the alley. The
          tarp was rolled back and they were checking the tops of all their
          crates. After a minute or two they seemed satisfied that everything
          was as they left it and hoped down out of the wagon.
        </span>
      </p>
      <p class="c0">
        <span class="c1"></span>
      </p>
      <p class="c2">
        <span class="c1">
          &ldquo;Let&rsquo;s get this out of the street. I want to get back to
          the fun and ale,&rdquo; announced Levant as he clapped his hands
          together.
        </span>
      </p>
      <p class="c0">
        <span class="c1"></span>
      </p>
      <p class="c2">
        <span class="c1">
          A few minutes later they were leading the wagon across a vacant market
          square in the direction of a store house. Botan was leading the horse
          team and Levant was keeping Andrew and Sam a little behind. Keeping
          them distracted by asking them questions and then pretending to be
          highly impressed with their answers, and then asking more details
          about their obvious lies as if their stories were wondrous. Botan
          suddenly turned into a store house, and the horses jumped into a
          sudden trot. Valer had to step quickly to avoid being hit by the rear
          wheel coming around, and increased his step to a &nbsp;jog to keep up.
          Andrew and Sam were a bit late to react to the event. They were so
          engrossed with impressing Levant they didn&rsquo;t notice until the
          rear of the wagon was disappearing past the doors.
        </span>
      </p>
      <p class="c0">
        <span class="c1"></span>
      </p>
      <p class="c2">
        <span class="c1">
          &ldquo;Whoa, hey! Hold up!&rdquo; cried Sam as he suddenly sprinted to
          catch up. Or rather tried to sprint. He was surprisingly slow.
          &ldquo;Where are you going!? The shipment&rsquo;s to go to the
          merchant house storehouse and nowhere else!&rdquo;
        </span>
      </p>
      <p class="c0">
        <span class="c1"></span>
      </p>
      <p class="c2">
        <span class="c1">
          Botan had stopped the team and wagon inside the strangely barren store
          house. No storehouse this close to the Bell market was ever barren,
          and they were all owned and run by the merchant house. As Valer was
          catching up to the turn of events, Botan came walking around the horse
          team casually to face Sam.
        </span>
      </p>
      <p class="c0">
        <span class="c1"></span>
      </p>
      <p class="c2">
        <span class="c1">
          &ldquo;Relax, this is the Merchant house&rsquo;s storehouse.&rdquo;
          Botan replied. His voice just as casual as his demeanor. &ldquo;Valer,
          would you please help us unload the crates? You don&rsquo;t need to,
          but it would go smoother with your expert help.&rdquo;
        </span>
      </p>
      <p class="c0">
        <span class="c1"></span>
      </p>
      <p class="c2">
        <span class="c1">
          Valer didn&rsquo;t really want to unload a bunch of crates, but he
          unlatched the back of the wagon deftly and dropped the gate. Getting
          to work.
        </span>
      </p>
      <p class="c0">
        <span class="c1"></span>
      </p>
      <p class="c2">
        <span class="c1">
          &ldquo;Hold on, the agreement was we&rsquo;d be paid, and only then
          the crates would be unloaded!&rdquo; Andrew protested. As Valer pulled
          the first crate out and let it fall to the ground. Creating a platform
          to make unloading the rest of the crates easier. At the sight of the
          crate dropping unceremoniously to the ground, a strangled sound
          emanated from the two men.
        </span>
      </p>
      <p class="c0">
        <span class="c1"></span>
      </p>
      <p class="c2">
        <span class="c1">
          {" "}
          &ldquo;Careful! Don&rsquo;t damage our goods!&rdquo;{" "}
        </span>
      </p>
      <p class="c0">
        <span class="c1"></span>
      </p>
      <p class="c2">
        <span class="c1">
          &ldquo;Come on man, they&rsquo;re filled with fur clothing! The boy
          can&rsquo;t hurt fur by dropping the boxes!&rdquo; Levan interjected.
          &ldquo;Don&rsquo;t you want to get back to before they drink all the
          whiskey?&rdquo;
        </span>
      </p>
      <p class="c0">
        <span class="c1"></span>
      </p>
      <p class="c2">
        <span class="c1">
          Andrew and Sam looked at each other then slowly shrugged their
          agreement. Not that Valer had slowed a hair at the sound of their
          protests. He had unloaded too many carts over the years to pay any
          attention to the lamenting of bystanders complaining about his work.
          If they wanted to do the heavy lifting, they were more than welcome.
        </span>
      </p>
      <p class="c0">
        <span class="c1"></span>
      </p>
      <p class="c2">
        <span class="c1">
          &ldquo;This is going to take forever.&rdquo; Said Levant loudly.
          &ldquo;It&rsquo;ll go a lot faster if you two help. Make sure Valer
          handles your boxes properly.&rdquo;
        </span>
      </p>
      <p class="c0">
        <span class="c1"></span>
      </p>
      <p class="c2">
        <span class="c1">
          Andrew and Sam looked at each other. Each gesturing for the other to
          go help, finally Sam pushed Andrew forward. Who stumbled a step
          forward and shot the other man a nasty look before resuming his fake
          smile and stepped up to the wagon. Valer, grinned back.
        </span>
      </p>
      <p class="c0">
        <span class="c1"></span>
      </p>
      <p class="c2">
        <span class="c1">
          &ldquo;Here you go!&rdquo; Valer chided cheerfully as he dropped a
          crate toward Andrew. Who made a sound like the wind just got knocked
          out of him and it crashed against the floor stones.
        </span>
      </p>
      <p class="c0">
        <span class="c1"></span>
      </p>
      <p class="c2">
        <span>&ldquo;</span>
        <span class="c7">Cyric </span>
        <span>help</span>
        <span class="c7">&nbsp;us</span>
        <span class="c1">
          ! Andrew! Come on!&rdquo; Cried Sam in apparent horror as the sound
          loudly echoed around the empty storehouse.
        </span>
      </p>
      <p class="c0">
        <span class="c1"></span>
      </p>
      <p class="c2">
        <span class="c1">
          In no more than 20 minutes Valer had all the crates unloaded and set
          out on the floor side by side. Twelve crates in total. Normally Valer
          would have stacked them all three high, but the crates were about a
          foot taller and wider than usual. Make them awkward to stack any more
          than two high as a single man lift. Also Levant kept gesturing for him
          to drop them next to each other instead of stacking them. Valer was
          starting to get the hang of this following the leader game, so all the
          boxes were laid out flat.
        </span>
      </p>
      <p class="c0">
        <span class="c1"></span>
      </p>
      <p class="c2">
        <span class="c1">
          Shortly after Valer dropped the last box, a man in Bridges Armor
          stepped through the open storehouse door. &ldquo;Sorry I&rsquo;m a bit
          late, Levant. The Keeper of the Bridges needed some extra paperwork
          last minute. Hope you didn&rsquo;t wait too long.&rdquo;
        </span>
      </p>
      <p class="c0">
        <span class="c1"></span>
      </p>
      <p class="c2">
        <span class="c1">
          &ldquo;Perfect timing actually. We just finished unloading.&rdquo;
          Replied Levant with a happy smile, which he turned to Andrew and Sam.
          &ldquo;Shall we get this inspection over with quickly?&rdquo; Definite
          panic painted Andrew and Sam&rsquo;s faces at the appearance of the
          bridge guard, and the announcement of an inspection.
        </span>
      </p>
      <p class="c0">
        <span class="c1"></span>
      </p>
      <p class="c2">
        <span class="c1">
          &ldquo;Uh..we can&rsquo;t, uh&rdquo; Sam said while tapping Andrew to
          say something.
        </span>
      </p>
      <p class="c0">
        <span class="c1"></span>
      </p>
      <p class="c2">
        <span class="c1">
          &ldquo;We, uh, yeah we can&rsquo;t.&rdquo; Stammered Andrew. Then
          suddenly, thinking of something, yelled loudly &ldquo;Without our boss
          here to oversee it!&rdquo;
        </span>
      </p>
      <p class="c0">
        <span class="c1"></span>
      </p>
      <p class="c2">
        <span class="c1">
          &ldquo;Yeah! Let&rsquo;s go get him Andrew! We&rsquo;ll run really
          quick to get him!&rdquo; Said Sam very sincerely.
        </span>
      </p>
      <p class="c0">
        <span class="c1"></span>
      </p>
      <p class="c2">
        <span class="c1">
          &ldquo;We&rsquo;re right here.&rdquo; Came Astrid&rsquo;s voice from
          the entrance as he and the middle man stepped through the wagon door.
          &ldquo;Don&rsquo;t worry, we&rsquo;ll get this inspection over
          quickly, and I saved plenty of that whiskey for those returning to the
          tavern.&rdquo;
        </span>
      </p>
      <p class="c0">
        <span class="c1"></span>
      </p>
      <p class="c2">
        <span class="c1">
          The middleman turned to Astrid. &ldquo;I&rsquo;ve never had an
          inspection on delivery before, and I&rsquo;m not going to pay for the
          guard&rsquo;s time. That comes from your expense if you insist on
          having one.&rdquo; His voice said this statement casually, and he
          didn&rsquo;t appear to be overly concerned.
        </span>
      </p>
      <p class="c0">
        <span class="c1"></span>
      </p>
      <p class="c2">
        <span class="c1">
          &ldquo;I&rsquo;m afraid it&rsquo;s standard practice for the
          merchant&rsquo;s house to have a guard in observation for these
          situations now.&rdquo; bowed Astrid. &ldquo;If it were up to me,
          we&rsquo;d just wrap this up, but I have my contract conditions as
          well.&rdquo;
        </span>
      </p>
      <p class="c0">
        <span class="c1"></span>
      </p>
      <p class="c2">
        <span>
          The middleman&rsquo;s knowing grin deepened. &ldquo;Well, in that
          case, let&#39;s get this over with. Andrew, if you would please open
          the <i>first crate.</i>&rdquo;
        </span>
      </p>
      <p class="c0">
        <span class="c1"></span>
      </p>
      <p class="c2">
        <span class="c1">
          Andrew walked slowly over to the crates, paused, and walked over to a
          box second from the end. Then looked over to his boss, who gave a nod
          and gestured for him to open the box. After a moment struggling with
          the crate lid it came loose and he opened the lid to show the interior
          of the box.Which appeared to be full of furs.
        </span>
      </p>
      <p class="c0">
        <span class="c1"></span>
      </p>
      <p class="c2">
        <span class="c1">
          &ldquo;Lift the coat up please Andrew.&rdquo; Grinned the middleman.
          &ldquo;Yes, good, in fact let&rsquo;s pull it all out. Hold each piece
          up please.&rdquo; Andrew lifted a pair of fur boots up, followed by
          another coat, followed by a pair of gloves. &ldquo;If you would be so
          kind as to bring them over here so that Astrid and the good guard can
          have a closer inspection.&rdquo;
        </span>
      </p>
      <p class="c0">
        <span class="c1"></span>
      </p>
      <p class="c2">
        <span class="c1">
          Andrew handed Astrid the coat, and the guard the pair of gloves.
          Astrid handed the coat to Levant, who gave an appreciative nod while
          he rubbed the furs and then handed it to Valer. It was a really nice
          coat. Heavy, and definitely high quality fur. Valer&rsquo;s dad had
          traded furs before, and these were high quality.
        </span>
      </p>
      <p class="c0">
        <span class="c1"></span>
      </p>
      <p class="c2">
        <span class="c1">
          &ldquo;Would you like to see another crate?&rdquo; Grinned the
          middleman. &ldquo;Sam, if you would please, open the second box and
          bring some samples over.&rdquo;
        </span>
      </p>
      <p class="c0">
        <span class="c1"></span>
      </p>
      <p class="c2">
        <span class="c1">
          Sam walked over to the boxes, pulled out a few so he could get access
          to a box in the middle of the pack and then again struggled to pry the
          lid open before finally standing back, holding the front of the lid
          open so everyone could see inside. Then pulled the lid off fully,
          lifted several fur articles from the box and brought them forward.
          Valer was again impressed with the quality. These were some good furs.
          If a southern buyer was found, they would be worth an extraordinary
          amount.
        </span>
      </p>
      <p class="c0">
        <span class="c1"></span>
      </p>
      <p class="c2">
        <span class="c1">
          &ldquo;These are some of the most excellent fur covers I&rsquo;ve
          seen!&rdquo; Announced Astrid.
        </span>
      </p>
      <p class="c0">
        <span class="c1"></span>
      </p>
      <p class="c2">
        <span>
          &ldquo;I told you they were!&rdquo; Chuckled the middleman. &ldquo;Now
          let&rsquo;s settle the payment, and wrap this up so I can buy{" "}
        </span>
        <span class="c7">you</span>
        <span class="c1">&nbsp;some whiskey.&rdquo;</span>
      </p>
      <p class="c0">
        <span class="c1"></span>
      </p>
      <p class="c2">
        <span class="c1">
          &ldquo;Unfortunately the merchant house requires all boxes to be
          opened prior to payment.&rdquo; Interjected Levant.
          &ldquo;Sorry.&rdquo; Then turning to Valer &ldquo;Would you mind
          helping the lads open the rest of them?&rdquo;
        </span>
      </p>
      <p class="c0">
        <span class="c1"></span>
      </p>
      <p class="c2">
        <span class="c1">
          &ldquo;No need,&rdquo; said the middleman. &ldquo;Andrew, Sam, open
          the rest. Carefully please.&rdquo; &nbsp;
        </span>
      </p>
      <p class="c0">
        <span class="c1"></span>
      </p>
      <p class="c2">
        <span class="c1">
          After roughly an hour, all the lids were propped against the side of
          the boxes. Fur visible in all the boxes. Andrew and Sam were sweaty
          and back united with their boss. Looking anxious but trying to seem
          casual as they watched their boss for what to do next.
        </span>
      </p>
      <p class="c0">
        <span class="c1"></span>
      </p>
      <p class="c2">
        <span class="c1">
          &ldquo;There you go,&rdquo; said the middleman. Shrugging and making
          wide gestures to all the open boxes. &ldquo;All, open, all
          inspected.&rdquo; Stepping up to the crate inspected earlier he picked
          up a coat and held it high. Giving it a little shake before dropping
          it back into its crate.
        </span>
      </p>
      <p class="c0">
        <span class="c1"></span>
      </p>
      <p class="c2">
        <span class="c1">
          &ldquo;Now, payment, please.&rdquo; said the middleman firmly, the
          charm in his demeanor thinning.
        </span>
      </p>
      <p class="c0">
        <span class="c1"></span>
      </p>
      <p class="c2">
        <span class="c1">
          Suddenly Botan moved forward and set his feet. Speaking something with
          a commanding voice and intonation, made a swift gesture with his hands
          as if parting curtains. All three men suddenly looked stricken with
          panic. Their heads whipping back and forth to each other. Seeming to
          search the area for what was happening, or what they should do. After
          a few seconds the middle man recovered his composure a bit and put on
          an offended stance. He ballooned his chest.
        </span>
      </p>
      <p class="c0">
        <span class="c1"></span>
      </p>
      <p class="c2">
        <span class="c1">
          &ldquo;Casting magic at us without warning, and without cause!&rdquo;
          the man scoffed. &ldquo;How dare you! You&rsquo;re trying to charm us!
          Thievery!&rdquo; an angry mask replaced the attempt at a charming
          smile that had been plastered on his face since Valer first saw him at
          the tavern. &ldquo;Sam! Andrew! Re-Load our wares! This deal is off!
          The merchant house is going to hear about this!&rdquo;
        </span>
      </p>
      <p class="c0">
        <span class="c1"></span>
      </p>
      <p class="c2">
        <span class="c1">
          &ldquo;All crates contain illusions,&rdquo; cut in Botan.
          &ldquo;Except for the two we inspected at the beginning.&rdquo; Botan
          stated this in a very audible and clearly understandable voice.
        </span>
      </p>
      <p class="c0">
        <span class="c1"></span>
      </p>
      <p class="c2">
        <span class="c1">
          Andrew and Sam moved quickly toward the crates. Valer stepped forward,
          blocking the path of both the men. Doing his best to glower as
          threateningly as he could. Which apparently worked, because they both
          stopped dead in their tracks. One of them, Valer thought it was
          Andrew, seemed to be gathering his courage.
        </span>
      </p>
      <p class="c0">
        <span class="c1"></span>
      </p>
      <p class="c2">
        <span class="c1">
          &ldquo;Lies!&rdquo; Screamed the middle man. A clear note of panic in
          his voice now. &ldquo;Andrew and Sam let&rsquo;s go. We have no words
          for thieves. Get those crates! If he doesn&rsquo;t move, hit
          him!&rdquo;
        </span>
      </p>
      <p class="c0">
        <span class="c1"></span>
      </p>
      <p class="c2">
        <span class="c1">
          Andrew, encouraged to action, balled a fist and raised it.
        </span>
      </p>
      <p class="c0">
        <span class="c1"></span>
      </p>
      <p class="c2">
        <span class="c1">Valer Hatch charged.</span>
      </p>
      <p class="c0">
        <span class="c1"></span>
      </p>
      <p class="c2">
        <span class="c1">
          In three quick broad steps he closed the distance and hit the man hard
          on the chin. Valer&rsquo;s fist continued to push the man&rsquo;s head
          well past the man&rsquo;s heels. Valer&rsquo;s body following the
          sword form boar in the brush that he&rsquo;d practiced so many times
          before. The man&rsquo;s feet lifted from the ground. Valer&rsquo;s
          body moved on its own. Boar in the brush transitioned to
          Smithy&rsquo;s hammer. The man hit the ground, bouncing and rolling.
          Quickly Valer pivoted to the second man, and stopped. Instead of an
          opponent, Valer was faced with the broad grins of Aster and Levant.
          They were both standing there smiling at him. The two other men were
          both laid out on the ground, completely unmoving.
        </span>
      </p>
      <p class="c0">
        <span class="c1"></span>
      </p>
      <p class="c2">
        <span class="c1">
          &ldquo;I win the bet!&rdquo; Announced Levant triumphantly.
        </span>
      </p>
      <p class="c0">
        <span class="c1"></span>
      </p>
      <p class="c2">
        <span class="c1">
          Aster turned to Levant, &ldquo;We aren&rsquo;t done here yet. Stop
          messing around.&rdquo;
        </span>
      </p>
      <p class="c0">
        <span class="c1"></span>
      </p>
      <p class="c2">
        <span class="c1">
          The man Valer hit was scrambling to flee. His feet move too fast
          against the stones for him to catch his balance, propelling him on all
          fours toward the door. Before Valer could move, he was out of
          arm&#39;s reach. Feet now pounding hard against the stones making
          great bid for freedom. His heart clearly in this like nothing else
          he&rsquo;d done tonight.
        </span>
      </p>
      <p class="c0">
        <span class="c1"></span>
      </p>
      <p class="c2">
        <span class="c1">
          &ldquo;I&rsquo;ve got him.&rdquo; Came Botans casual voice, and again
          he spoke something very clearly while he deftly pulled something from
          his sleeve and simultaneously made a strong gesture that looked
          something like the sword form &ldquo;grasping horns&rdquo;. Suddenly
          the man&rsquo;s feet stopped pumping and he sprawled awkwardly across
          the ground. Flopping in an uncontrolled manner to the ground with a
          loud slap and thud. Tumbling to a halt in a limp floppy mass.
        </span>
      </p>
      <p class="c0">
        <span class="c1"></span>
      </p>
      <p class="c2">
        <span class="c1">
          Aster walked over to where the man lay, grabbed him by the ankle, and
          unceremoniously drug the limp man back to where the other two lay.
          Then proceeded to line them up next to each other in a row. The bridge
          guard pulled some rope from behind his breast plate and tied all three
          mens&rsquo; hands behind their back with a practiced skill. Levant
          offered him some extra rope to tie their ankles which he accepted
          gratefully. When the guard was done he stood, smiled, and shook his
          head. A look of impressed incredulity on his face as he looked at the
          three retired adventurers.
        </span>
      </p>
      <p class="c0">
        <span class="c1"></span>
      </p>
      <p class="c2">
        <span class="c1">
          &ldquo;They told me you three were impressive, but I don&rsquo;t think
          I&rsquo;ve ever seen anything quite like that show.&rdquo; He said,
          shaking his head. &ldquo;The way you moved Aster, that was impressive.
          &nbsp;Judging from how wide his eyes got he saw you coming but he
          could as well have stopped a charging orc chieftain as you.&rdquo;
        </span>
      </p>
      <p class="c0">
        <span class="c1"></span>
      </p>
      <p class="c2">
        <span class="c1">
          Astrid gave a short laugh. &ldquo;Oh he&rsquo;d have had better luck
          with that chieftain. Trust me.&rdquo;
        </span>
      </p>
      <p class="c0">
        <span class="c1"></span>
      </p>
      <p class="c2">
        <span class="c1">
          &ldquo;And he trains with you Astrid if I guess right?&rdquo; Said the
          guard pointing to Valer Hatch.
        </span>
      </p>
      <p class="c0">
        <span class="c1"></span>
      </p>
      <p class="c2">
        <span class="c1">
          &ldquo;You guess right,&rdquo; said Astrid proudly. &ldquo;One of my
          younger students, but he&rsquo;s got a great aptitude. Moves well
          doesn&rsquo;t he!&rdquo; Astrid beamed.
        </span>
      </p>
      <p class="c0">
        <span class="c1"></span>
      </p>
      <p class="c2">
        <span class="c1">
          The guard turned to Botan. &ldquo;Alright, well, Baton is it?&rdquo;
        </span>
      </p>
      <p class="c0">
        <span class="c1"></span>
      </p>
      <p class="c2">
        <span class="c1">&ldquo;Botan.&rdquo; </span>
      </p>
      <p class="c0">
        <span class="c1"></span>
      </p>
      <p class="c2">
        <span class="c1">
          &ldquo;Sorry. Botan.&rdquo; The guard nodded his head in apology.
          &ldquo;Show me this illusion swindle Alexis Hickory reported last
          month, and I&rsquo;ll get the paperwork started.&rdquo;
        </span>
      </p>
      <p class="c2">
        <span class="c1">
          The group walked over to the open crates full of furs. They all looked
          just like the furs they had passed around. Botan offered an
          explanation of sorts in a bare handful of words. Which didn&rsquo;t
          make any sense to Valer Hatch. Something about light and magic was all
          he gathered. Apprehensive to approach now they knew the crates
          contained magic everyone stopped before getting within arms reach.
          Except for Botan who continued right up to one of the first crates.
        </span>
      </p>
      <p class="c0">
        <span class="c1"></span>
      </p>
      <p class="c2">
        <span class="c1">
          &ldquo;They are perfectly safe.&rdquo; Botan sighed, shaking his head,
          a suffering grin on his face. He reached his hand into the first box.
          Except the furs didn&rsquo;t react to his hand pressing down.
          Botan&rsquo;s hand seemed to pass straight through the furs as if they
          weren&rsquo;t there. Botan laughed at the startled expressions that
          must have been on their faces. Again Botan chuckled and shook his head
          before turning his attention to the crate. His hand made a kind of
          brushing motion. Like he was brushing away dirt. Then Botan started
          scooping, and throwing sand and sticks out of the box onto the floor.
        </span>
      </p>
      <p class="c0">
        <span class="c1"></span>
      </p>
      <p class="c2">
        <span class="c1">
          After a moment of digging, the image of the furs disappeared.The crate
          was now filled with what looked like a mess of dirt and sticks. Botan
          stood clutching something in his hand. He turned and showed them what
          appeared to be a wooden coin sitting in the palm of his hand.
        </span>
      </p>
      <p class="c0">
        <span class="c1"></span>
      </p>
      <p class="c2">
        <span class="c1">
          &ldquo;Seems they put a weak illusion enchantment on this.&rdquo;
          Botan stated. &ldquo;On such crude material and workmanship, even the
          strongest enchantment would fade in no more than a week. Just enough
          to pass a simple visual inspection. Put on a bit of a show.&rdquo; He
          gestured to the crates sitting open. &ldquo;Honestly I&rsquo;m more
          curious about how they pulled off the enchantment. There&rsquo;s no
          way any of these men have the skill or aptitude to perform
          enchantments.&rdquo; Botan set the coin down on the corner of the
          crate and the illusion sprung back into being. A strange picture of a
          cube of bundled furs overlapping the edges of the boxes.
        </span>
      </p>
      <p class="c2">
        <span class="c1">
          <br />
          The guard stepped forward, nervously rubbed his hands together, then
          leaned down and took the coin. The illusion winking out again.
          &ldquo;You&rsquo;re sure holding this is safe?&rdquo; He asked Botan.
        </span>
      </p>
      <p class="c0">
        <span class="c1"></span>
      </p>
      <p class="c2">
        <span class="c1">
          &ldquo;Yes&rdquo; he replied encouragingly. &ldquo;I suggest you get
          another wizard to do an inspection quickly before the enchantment
          wears off.&rdquo; Then pointed at the wooden coin in the guard hand.
          &ldquo;I&rsquo;d be willing to submit an official inspection for my
          regular fee.&rdquo;
        </span>
      </p>
      <p class="c0">
        <span class="c1"></span>
      </p>
      <p class="c2">
        <span class="c1">
          &ldquo;I&rsquo;ll speak with the Keeper of the Bridges. He&rsquo;ll
          send a messenger to fetch you tonight if needed&rdquo; replied the
          guard nodding. Then he raised a square polished stone to his mouth and
          said &ldquo;Lovett, Sarthun&rsquo;s Shield picked up the swindlers as
          contracted. I&rsquo;ve got three to carry, and let the Keeper
          know&hellip;&rdquo;
        </span>
      </p>
      <p class="c0">
        <span class="c1"></span>
      </p>
      <p class="c2">
        <span class="c1">
          Valer stopped listening as Levant, Botan, and Aster stepped over to
          him. Botan looked relaxed as usual, Levant had a broad smile and
          excited eyes, while Aster had a subtle approving look about him.
        </span>
      </p>
      <p class="c0">
        <span class="c1"></span>
      </p>
      <p class="c2">
        <span class="c1">
          &ldquo;Great Job Hatch!&rdquo; Announced Levant. &ldquo;You&rsquo;d
          make a great adventurer!&rdquo; Levant chuckled as he said this.
          Shaking his head slightly in what seemed to be shocked approval.
          &ldquo;From the tavern, to the brawl. You did well.&rdquo;
        </span>
      </p>
      <p class="c0">
        <span class="c1"></span>
      </p>
      <p class="c2">
        <span class="c1">
          &ldquo;Okay Levant, let&rsquo;s not fill his head too much,&rdquo;
          cautioned Aster. Then turning to Valer &ldquo;You did well. I
          didn&rsquo;t know you were going to be joining us tonight, but
          I&rsquo;m glad you did.&rdquo; Then clapping a hand on Valer&rsquo;s
          shoulder, &ldquo;in another four years you will be handling all three
          of these men with no help at all.&rdquo;
        </span>
      </p>
      <p class="c0">
        <span class="c1"></span>
      </p>
      <p class="c2">
        <span class="c1">
          Valer couldn&rsquo;t stop himself from grinning at the praise from
          these seasoned adventurers. Though he couldn&rsquo;t help feeling a
          bit of sting at Aster&rsquo;s words hinting he wasn&rsquo;t ready.
          That he still needed to be trained with kiddie gloves, but decided not
          to spoil the night with bristles. &ldquo;Thanks for inviting me
          Levant. This was a night to remember.&rdquo;
        </span>
      </p>
      <p class="c0">
        <span class="c1"></span>
      </p>
      <p class="c2">
        <span class="c1">
          &ldquo;From speaking with your father and Astrid, you might have a
          knack for some magic.&rdquo; Botan said, adding to the praise.
          &ldquo;From what I observed tonight, I think they might be
          right.&rdquo; Botan made a noncommittal gesture to the air.
          &ldquo;Think about it. If you are interested, let Astrid know and
          we&rsquo;ll do a more in depth analysis of your aptitude.&rdquo; At
          this both Aster and Levant looked at each other in apparent surprise,
          before both turning an awed look on Botan. Who casually ignored them,
          acting as if he didn&rsquo;t say anything out of character.
        </span>
      </p>
      <p class="c0">
        <span class="c1"></span>
      </p>
      <p class="c2">
        <span class="c1">
          A moment later the guard approached the group and interrupted their
          praise of Hatch. &ldquo;By rights granted in the contract, any trade
          items, the furs, and any gold or valuables the men owned, that
          aren&rsquo;t required for their trial, belong to Sarthun&rsquo;s
          Shield.&rdquo; He announced in a formal manner. &ldquo;I have some men
          coming to gather everything up. So make your collections quickly. Have
          a good evening. I have paperwork to do.&rdquo;
        </span>
      </p>
      <p class="c0">
        <span class="c1"></span>
      </p>
      <p class="c2">
        <span class="c1">
          Hatch watched as the three members of Sarthun&rsquo;s shield first
          searched the three tied men and pocketed everything they found, then
          stacked the fur clothes and gloves and boots high in their arms.
        </span>
      </p>
      <p class="c0">
        <span class="c1"></span>
      </p>
      <p class="c2">
        <span class="c1">
          &ldquo;Hey Hatch, do you want those furs? We can&rsquo;t carry them,
          and once we walk away our rights are forfeit. So load up
          brother!&rdquo; Levant called around the pile of furs in his arms.
        </span>
      </p>
      <p class="c0">
        <span class="c1"></span>
      </p>
      <p class="c2">
        <span class="c1">
          &ldquo;Yes. Yes I do want those furs,&rdquo; he replied. An idea
          slowly hatching in his head.
        </span>
      </p>
    </>
  );
}
